import { Directive, OnInit, ViewParent } from 'angular-ts-decorators';
import { SwChange } from '../classes/sw-change';

/**
 * Directive that connects ng-model with sw-change-wrapper
 *
 * # Example
 * <pre>
 *   <input sw-change-notifier ng-model="test"/>
 * </pre>
 */
@Directive({
  selector: '[sw-change-notifier]',
  bindToController: true,
})
export class SwChangeNotifierDirective extends SwChange implements OnInit {
  @ViewParent('?') private ngModel: ng.INgModelController;

  constructor() {
    'ngInject';
    super();
  }

  ngOnInit() {
    this.ngModel.$viewChangeListeners.push(() => {
      if (this.ngModel.$valid) {
        this.change(this.ngModel.$modelValue);
      }
    });
  }
}
